/* SM24_CART_LOCALE_ROOT_v1 2026-11-03: all cart fetches use Shopify.routes.root so /en gets English drawer + titles */
/* ============================================================
   ShopMed24 — B2B Product Page JavaScript
   File: assets/b2b-product.js
   Loaded by: sections/b2b-product-hero.liquid
   Reads product data from: window.B2B_DATA (set inline by hero section)
   ============================================================ */

(function () {
  'use strict';

  /* SM24_JS_LOCALE_v1 2026-10-17: UI strings follow the storefront language.
     Toasts / list modal were English-only (leaked onto /de), the generated
     datasheet was German-only (leaked onto /en). */
  var SM24_DE = !!(window.Shopify && window.Shopify.locale === 'de');
  function sm24t(en, de) { return SM24_DE ? de : en; }
  var SM24_DS_EN = [
    ['lang="de"', 'lang="en"'], ['Datenblatt – ', 'Data Sheet – '], ['<strong>Produktdatenblatt</strong>', '<strong>Product Data Sheet</strong>'],
    ['Dok.-Nr.: ', 'Doc. no.: '], ['Datum: ', 'Date: '], ['Erstellt für: B2B-Kunden', 'Prepared for: B2B customers'],
    ['Art.-Nr.: ', 'Item no.: '], ['Preis pro VE (inkl. MwSt.)', 'Price per packaging unit (incl. VAT)'], ['>/ VE</span>', '>/ unit</span>'],
    ['UVP: ', 'RRP: '],
    ['<h2>Produktspezifikationen</h2>', '<h2>Product specifications</h2>'], ['<td>Artikelbezeichnung</td>', '<td>Product name</td>'],
    ['<td>Artikelnummer (SKU)</td>', '<td>Item number (SKU)</td>'], ['<td>Lieferant / Hersteller</td>', '<td>Supplier / Manufacturer</td>'],
    ['<td>Preis pro VE</td>', '<td>Price per packaging unit</td>'],
    ['<td>Liefergebiet</td><td>Deutschland, Österreich, Schweiz (DACH)</td>', '<td>Delivery area</td><td>Germany, Austria, Switzerland (DACH)</td>'],
    ['<td>Produktseite</td>', '<td>Product page</td>'], ['<h2>Verfügbare Varianten</h2>', '<h2>Available variants</h2>'],
    ['>Variante</th>', '>Variant</th>'], ['>Preis/VE</th>', '>Price/unit</th>'], ['<h2>Produktbeschreibung</h2>', '<h2>Product description</h2>'],
    ['<strong>Hinweis:</strong> Dieses Produkt ist ausschließlich für zugelassene B2B-Kunden (Krankenhäuser, Kliniken, Praxen) bestimmt. Alle Angaben ohne Gewähr. Technische Änderungen vorbehalten. Bei Fragen wenden Sie sich an',
     '<strong>Note:</strong> This product is intended exclusively for approved B2B customers (hospitals, clinics, practices). All information without guarantee. Technical changes reserved. For questions please contact'],
    ['Seite 1 / 1 · Dok. ', 'Page 1 / 1 · Doc. '], ['🖨 Als PDF speichern', '🖨 Save as PDF'], ['>Produktname</h1>', '>Product name</h1>']
  ];
  function sm24LocalizeDatasheet(html) {
    if (SM24_DE) return html;
    SM24_DS_EN.forEach(function (pair) { html = html.split(pair[0]).join(pair[1]); });
    return html;
  }

  /* ── Wait for DOM ── */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ================================================================
     CART REFRESH — updates Xtra theme cart count bubble + opens drawer
     Xtra uses ajaxCart (custom-async.js) which exposes ajaxCart.load()
     to reload the side-cart. We also fetch /cart.js directly to update
     the #cart-count element immediately (no waiting for section re-render).
  ================================================================ */
  window.b2bRefreshCart = function () {
    var cartBust = '_=' + Date.now();

    // STEP 1 — Fetch canonical cart state (no-store so Shopify CDN is bypassed)
    var cartStatePromise = fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart.js?' + cartBust, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Header count badge (pure text span — safe to overwrite)
        var countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;

        // Dedicated ShopMed24 count bubbles (text-only)
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        // data-totalqty/totalprice live on elements that contain child nodes
        // (like the drawer's <header><h3>Warenkorb</h3></header>). ONLY touch
        // the attribute — never textContent — or we destroy the heading.
        document.querySelectorAll('[data-totalqty]').forEach(function (el) {
          if (el.dataset) el.dataset.totalqty = cart.item_count;
        });
        document.querySelectorAll('[data-totalprice]').forEach(function (el) {
          if (el.dataset && cart.total_price != null) {
            el.dataset.totalprice = cart.total_price;
          }
        });
        return cart;
      })
      .catch(function () { return null; });

    // STEP 2 — Fetch the side-cart section fresh and inject it BEFORE
    // opening the panel (so Xtra's ajaxCart.load just shows current content).
    // This bypasses Shopify's cached section response entirely.
    var sectionPromise = fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + '?section_id=side-cart&' + cartBust, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The section endpoint returns the raw section content — find the wrapper
        // or fall back to the document body.
        var section = doc.querySelector('#shopify-section-side-cart');
        var markup = section ? section.innerHTML : doc.body.innerHTML;
        var container = document.getElementById('cart');
        if (container && markup) {
          container.innerHTML = markup;
        }
      })
      .catch(function (err) {
        if (window.console) console.warn('[b2bRefreshCart] section fetch failed', err);
      });

    // STEP 3 — After both fetches complete, open the drawer (if ajaxCart ready)
    Promise.all([cartStatePromise, sectionPromise]).then(function () {
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        // Fresh content is already in the drawer — just open it
        window.ajaxCart.load();
      }
      // Rebind Xtra's event handlers on the freshly-injected content
      try {
        window.dispatchEvent(new CustomEvent('modulePanel'));
        window.dispatchEvent(new CustomEvent('listCart'));
        window.dispatchEvent(new CustomEvent('semanticInput'));
        window.dispatchEvent(new CustomEvent('formValidate'));
        window.dispatchEvent(new CustomEvent('accordeon'));
      } catch (e) { /* non-fatal */ }
    });

    // Legacy event fallbacks
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('listCart'));
  };

  /* ================================================================
     GALLERY
  ================================================================ */
  window.b2bSwitchImage = function (idx) {
    var thumbs = document.querySelectorAll('.b2b-thumb');
    var img = document.getElementById('b2bMainImage');
    if (!thumbs[idx] || !img) return;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumbs[idx].classList.add('active');
    var src = thumbs[idx].dataset.src;
    if (src) img.src = src;
  };

  /* ================================================================
     QUANTITY STEPPER
  ================================================================ */
  window.b2bChangeQty = function (delta) {
    var input = document.getElementById('b2bQtyInput');
    if (!input) return;
    var min = parseInt(input.min) || 1;
    var step = parseInt(input.step) || min;
    var val = Math.max(min, (parseInt(input.value) || min) + delta);
    // snap to step
    val = Math.round(val / step) * step;
    if (val < min) val = min;
    input.value = val;
    b2bQtyChanged(input);
  };

  window.b2bQtyChanged = function (inp) {
    var min = parseInt(inp.min) || 1;
    var val = Math.max(min, parseInt(inp.value) || min);
    inp.value = val;
    var hiddenQty = document.getElementById('b2bQtyHidden');
    if (hiddenQty) hiddenQty.value = val;
    b2bUpdateCart(val);
    // sync procurement modal qty display
    var plQty = document.getElementById('b2bPlQty');
    if (plQty) plQty.textContent = val;
  };

  /* ================================================================
     CART TOTAL & SHIPPING BAR
  ================================================================ */
  function b2bUpdateCart(qty) {
    var data = window.B2B_DATA || {};
    var pricePerUnit = (data.price || 0) / 100; // price in cents → euros
    var total = qty * pricePerUnit;

    var totalStr = b2bFormatEUR(Math.round(total * 100));
    var totalEl = document.getElementById('b2bCartTotal');
    if (totalEl) totalEl.textContent = totalStr;
    // Mobile total price row
    var mobileTotalEl = document.getElementById('b2bMobileTotalPrice');
    if (mobileTotalEl) mobileTotalEl.textContent = totalStr;
    /* Free shipping progress bar removed — shipping is per-supplier */
  }

  /* ================================================================
     VOLUME TIER SELECTION
  ================================================================ */
  window.b2bSelectTier = function (el, qty, priceInCents) {
    document.querySelectorAll('.b2b-tier').forEach(function (r) { r.classList.remove('selected'); });
    el.classList.add('selected');
    // update qty input
    var input = document.getElementById('b2bQtyInput');
    if (input) {
      input.value = qty;
      var hiddenQty = document.getElementById('b2bQtyHidden');
      if (hiddenQty) hiddenQty.value = qty;
    }
    // update displayed price (force EUR)
    var eurStr = b2bFormatEUR(priceInCents);
    var dp = document.getElementById('b2bDisplayPrice');
    if (dp) dp.textContent = eurStr;
    var sp = document.getElementById('b2bStickyPrice');
    if (sp) sp.textContent = eurStr;
    var msp = document.getElementById('b2bMobileStickyPrice');
    if (msp) msp.textContent = eurStr;
    // update global price for cart calc
    if (window.B2B_DATA) window.B2B_DATA.price = priceInCents;
    b2bUpdateCart(qty);
    // sync procurement modal qty
    var plQty = document.getElementById('b2bPlQty');
    if (plQty) plQty.textContent = qty;
  };

  /* ================================================================
     VARIANT SELECTION
  ================================================================ */
  /* SM24 2026-07-14: shared variant-apply logic, used by both the pill buttons
     and the new dropdown (SM24_VARIANT_DROPDOWN_v1). */
  window.b2bApplyVariant = function (variantId, priceInCents, comparePriceInCents) {
    // Update hidden variant input
    var variantInput = document.getElementById('b2bVariantId');
    if (variantInput) variantInput.value = variantId;
    // Update global price
    if (window.B2B_DATA) window.B2B_DATA.price = priceInCents;
    // Update displayed price (force EUR)
    var varEurStr = b2bFormatEUR(priceInCents);
    var dp = document.getElementById('b2bDisplayPrice');
    if (dp) dp.textContent = varEurStr;
    var sp2 = document.getElementById('b2bStickyPrice');
    if (sp2) sp2.textContent = varEurStr;
    var msp2 = document.getElementById('b2bMobileStickyPrice');
    if (msp2) msp2.textContent = varEurStr;
    // Update compare price
    var cp = document.getElementById('b2bComparePrice');
    if (cp) {
      if (comparePriceInCents && comparePriceInCents > priceInCents) {
        cp.textContent = b2bFormatEUR(comparePriceInCents);
        cp.style.display = '';
      } else {
        cp.style.display = 'none';
      }
    }
    // Recalc cart total
    var qty = parseInt((document.getElementById('b2bQtyInput') || {}).value) || (window.B2B_DATA && window.B2B_DATA.minQty) || 1;
    b2bUpdateCart(qty);
  };

  /* Pill-button picker (still used by main-product-b2b.liquid). */
  window.b2bSelectVariant = function (btn, variantId, priceInCents, comparePriceInCents) {
    document.querySelectorAll('.b2b-variant-btn').forEach(function (b) {
      b.style.borderColor = '';
      b.style.background = '';
      b.style.fontWeight = '500';
      b.classList.remove('selected');
    });
    btn.style.borderColor = 'var(--b2b-accent, #6ba4b8)';
    btn.style.background = '#f4f8fa';
    btn.style.fontWeight = '700';
    btn.classList.add('selected');
    window.b2bApplyVariant(variantId, priceInCents, comparePriceInCents);
  };

  /* SM24_VARIANT_DROPDOWN_v1 — dropdown picker (b2b-product-hero.liquid).
     Scales to products with many packaging variants, where a pill row got unusably tall. */
  window.b2bSelectVariantDropdown = function (sel) {
    var o = sel.options[sel.selectedIndex];
    if (!o) return;
    window.b2bApplyVariant(
      o.value,
      parseInt(o.getAttribute('data-price'), 10) || 0,
      parseInt(o.getAttribute('data-compare'), 10) || 0
    );
  };

  /* ================================================================
     PRODUCT TABS (desktop)
  ================================================================ */
  window.b2bSwitchTab = function (id, clickedBtn) {
    document.querySelectorAll('.b2b-tab-panel').forEach(function (p) { p.classList.remove('active'); p.style.display = 'none'; });
    document.querySelectorAll('.b2b-tab-btn').forEach(function (b) { b.classList.remove('active'); });
    var panel = document.getElementById('b2b-tab-' + id);
    if (panel) { panel.classList.add('active'); panel.style.display = 'block'; }
    if (clickedBtn) clickedBtn.classList.add('active');
  };

  /* ================================================================
     ACCORDIONS (mobile tabs + FAQ)
  ================================================================ */
  window.b2bToggleAcc = function (header) {
    var body = header.nextElementSibling;
    if (!body) return;
    var isOpen = body.classList.contains('open');
    header.classList.toggle('open', !isOpen);
    body.classList.toggle('open', !isOpen);
  };

  /* ================================================================
     TOAST
  ================================================================ */
  window.b2bShowToast = function (msg, duration) {
    var t = document.getElementById('b2bToast');
    if (!t) return;
    var msgEl = document.getElementById('b2bToastMsg');
    if (msgEl) msgEl.textContent = msg;
    t.classList.remove('hidden');
    t.classList.add('in');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () {
      t.classList.remove('in');
      t.classList.add('hidden');
    }, duration || 2800);
  };

  /* ================================================================
     PROCUREMENT LISTS (localStorage)
     On Shopify live: replace with Customer Metafields API calls
  ================================================================ */
  // KEY must match dashboard (main-account.liquid) which reads 'b2b_procurement_lists_v2'
  var PL_KEY = 'b2b_procurement_lists_v2';

  function plGetLists() {
    try {
      var raw = localStorage.getItem(PL_KEY);
      if (!raw) {
        var seed = [
          { name: sm24t('Weekly Restock', 'Wöchentlicher Nachkauf'), products: [], updatedAt: Date.now() },
          { name: sm24t('Monthly Order', 'Monatsbestellung'), products: [], updatedAt: Date.now() },
          { name: sm24t('Clinic A — OR Kit', 'Klinik A — OP-Set'), products: [], updatedAt: Date.now() }
        ];
        localStorage.setItem(PL_KEY, JSON.stringify(seed));
        return seed;
      }
      return JSON.parse(raw);
    } catch (e) { return []; }
  }

  function plSave(lists) { localStorage.setItem(PL_KEY, JSON.stringify(lists)); }

  function plInList(list) {
    var data = window.B2B_DATA || {};
    // Match by productId (stored as string) or SKU
    return (list.products || []).some(function (p) {
      return (p.productId && p.productId === String(data.productId)) ||
             (p.sku && data.sku && p.sku === data.sku);
    });
  }

  window.b2bOpenProcurementModal = function () {
    b2bRenderProcurementModal();
    var m = document.getElementById('b2bProcurementModal');
    if (m) { m.classList.remove('hidden'); document.body.style.overflow = 'hidden'; }
  };

  window.b2bCloseProcurementModal = function () {
    var m = document.getElementById('b2bProcurementModal');
    if (m) { m.classList.add('hidden'); document.body.style.overflow = ''; }
  };

  function b2bRenderProcurementModal() {
    var lists = plGetLists();
    var container = document.getElementById('b2bProcurementLists');
    var qty = (document.getElementById('b2bQtyInput') || {}).value || 1;
    if (!container) return;

    if (lists.length === 0) {
      container.innerHTML = '<div style="text-align:center;padding:28px 0 20px"><span class="mat-icon material-symbols-outlined" style="font-size:36px;color:#e5e7eb;display:block;margin-bottom:8px">folder_open</span><p style="font-size:14px;color:#9ca3af;margin:0">' + sm24t('No lists yet. Create your first one below.', 'Noch keine Listen. Erstellen Sie unten Ihre erste Liste.') + '</p></div>';
    } else {
      container.innerHTML = lists.map(function (l) {
        var inList = plInList(l);
        var cnt = (l.products || []).length;
        var cntLabel = SM24_DE ? (cnt + ' Produkt' + (cnt === 1 ? '' : 'e')) : (cnt + ' product' + (cnt === 1 ? '' : 's'));
        var inListSpan = inList ? ' &middot; <span style="color:#6ba4b8;font-weight:600">' + sm24t('In list', 'In Liste') + '</span>' : '';
        var cardBorder = inList ? '1.5px solid #6ba4b8' : '1.5px solid rgba(197,198,205,0.3)';
        var cardBg     = inList ? 'rgba(107,164,184,0.05)' : 'transparent';
        var iconBg     = inList ? '#6ba4b8' : '#f4f8fa';
        var iconColor  = inList ? '#fff' : '#6ba4b8';
        var iconFill   = inList ? 1 : 0;
        var iconName   = inList ? 'check_circle' : 'folder';
        var actionIcon = inList ? 'check' : 'add';
        var actionColor = inList ? '#6ba4b8' : 'rgba(197,198,205,0.6)';
        // Use <div role="button"> to bypass Xtra theme button CSS overrides
        // Use list name as ID (dashboard has no id field, uses array index)
        var safeId = encodeURIComponent(l.name);
        return '<div role="button" tabindex="0" onclick="b2bToggleProcurementItem(\'' + safeId + '\')" onkeydown="if(event.key===\'Enter\'||event.key===\' \')b2bToggleProcurementItem(\'' + safeId + '\')" '
          + 'style="display:flex;align-items:center;gap:12px;padding:14px;border-radius:12px;border:' + cardBorder + ';background:' + cardBg + ';cursor:pointer;margin-bottom:8px;transition:border-color .15s,background .15s;font-family:\'Satoshi\',Inter,sans-serif">'
          + '<div style="width:40px;height:40px;border-radius:10px;background:' + iconBg + ';display:flex;align-items:center;justify-content:center;flex-shrink:0">'
          + '<span class="mat-icon material-symbols-outlined" style="color:' + iconColor + ';font-size:20px;font-variation-settings:\'FILL\' ' + iconFill + '">' + iconName + '</span></div>'
          + '<div style="flex:1;min-width:0">'
          + '<div style="font-size:14px;font-weight:700;color:#1f2e35;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-family:\'Satoshi\',Inter,sans-serif">' + l.name + '</div>'
          + '<div style="font-size:12px;color:#6b7280;font-family:\'Satoshi\',Inter,sans-serif">' + cntLabel + inListSpan + '</div>'
          + '</div>'
          + '<span class="mat-icon material-symbols-outlined" style="color:' + actionColor + ';font-size:20px;flex-shrink:0">' + actionIcon + '</span>'
          + '</div>';
      }).join('');
    }
    // Update qty display
    var plQty = document.getElementById('b2bPlQty');
    if (plQty) plQty.textContent = qty;
  }

  window.b2bToggleProcurementItem = function (listId) {
    var lists = plGetLists();
    // listId is URL-encoded list name (dashboard has no id, uses array index)
    var listName = decodeURIComponent(listId);
    var list = lists.find(function (l) { return l.name === listName || l.id === listId; });
    if (!list) return;
    var data = window.B2B_DATA || {};
    var qty = parseInt((document.getElementById('b2bQtyInput') || {}).value) || 1;
    // Use products array (dashboard-compatible)
    if (!list.products) list.products = [];
    var idx = list.products.findIndex(function (p) {
      return (p.productId && p.productId === String(data.productId)) ||
             (p.sku && data.sku && p.sku === data.sku);
    });
    if (idx === -1) {
      list.products.push({
        name: data.title || '',        // dashboard reads 'name'
        productId: String(data.productId),
        handle: data.handle || '',
        sku: data.sku || '',
        price: data.price || 0,
        qty: qty,
        unit: 'Stück',
        variantId: data.variantId || null,
        image: data.image || '',
        vendor: data.vendor || '',
        addedAt: Date.now()
      });
      list.updatedAt = Date.now();
      b2bShowToast(sm24t('Added to ', 'Hinzugefügt zu ') + list.name);
    } else {
      list.products.splice(idx, 1);
      list.updatedAt = Date.now();
      b2bShowToast(sm24t('Removed from ', 'Entfernt aus ') + list.name);
    }
    plSave(lists);
    b2bRenderProcurementModal();
    b2bRenderProcurementIcon();
  };

  function b2bRenderProcurementIcon() {
    var icon = document.getElementById('b2bProcurementIcon');
    var btn  = document.getElementById('b2bProcurementBtn');
    if (!icon || !btn) return;
    var inAny = plGetLists().some(function (l) { return plInList(l); });
    // SM24_PL_BTN_RESET_SAFE_v1: state styling is CSS (.active) in b2b-product-hero.liquid;
    // plain inline styles are wiped by the `.b2b-page button { all:unset !important }` reset.
    btn.classList.toggle('active', inAny);
    icon.textContent = inAny ? 'bookmark_added' : 'bookmark_add';
    icon.style.fontVariationSettings = inAny ? "'FILL' 1" : "'FILL' 0";
    icon.style.color = '';
  }

  window.b2bShowCreateListForm = function () {
    var form   = document.getElementById('b2bCreateListForm');
    var toggle = document.getElementById('b2bCreateListToggle');
    if (form)   form.classList.remove('hidden');
    if (toggle) toggle.classList.add('hidden');
    setTimeout(function () {
      var inp = document.getElementById('b2bNewListName');
      if (inp) inp.focus();
    }, 50);
  };

  window.b2bHideCreateListForm = function () {
    var form   = document.getElementById('b2bCreateListForm');
    var toggle = document.getElementById('b2bCreateListToggle');
    if (form)   form.classList.add('hidden');
    if (toggle) toggle.classList.remove('hidden');
    var inp = document.getElementById('b2bNewListName');
    if (inp) inp.value = '';
  };

  window.b2bCreateNewList = function () {
    var inp  = document.getElementById('b2bNewListName');
    var name = inp ? inp.value.trim() : '';
    if (!name) { if (inp) inp.focus(); return; }
    var lists = plGetLists();
    lists.push({ name: name, products: [], updatedAt: Date.now() });
    plSave(lists);
    b2bHideCreateListForm();
    b2bRenderProcurementModal();
    b2bShowToast(sm24t('List "' + name + '" created', 'Liste „' + name + '“ erstellt'));
  };

  /* ================================================================
     RFQ MODAL
  ================================================================ */
  window.b2bOpenQuoteModal = function () {
    var qty    = (document.getElementById('b2bQtyInput') || {}).value || 1;
    var rfqQty = document.getElementById('b2bRfqQty');
    if (rfqQty) rfqQty.value = qty;
    var m = document.getElementById('b2bQuoteModal');
    if (m) { m.classList.remove('hidden'); document.body.style.overflow = 'hidden'; }
  };

  window.b2bCloseQuoteModal = function () {
    var m = document.getElementById('b2bQuoteModal');
    if (m) { m.classList.add('hidden'); document.body.style.overflow = ''; }
  };

  window.b2bSubmitQuote = function (e) {
    e.preventDefault();
    var form = e.target;
    var submitBtn = form.querySelector('button[type="submit"]');
    var origHTML  = submitBtn ? submitBtn.innerHTML : '';

    // Validate required fields
    var requiredFields = form.querySelectorAll('[required]');
    var valid = true;
    requiredFields.forEach(function(f) {
      if (!f.value.trim()) { f.style.borderColor = '#dc2626'; valid = false; }
      else f.style.borderColor = '';
    });
    if (!valid) return false;

    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '⏳ Sending...'; }

    // Build URLSearchParams from all named inputs
    var data = new URLSearchParams({ 'form_type': 'contact', 'utf8': '✓' });
    var inputs = form.querySelectorAll('[name]');
    inputs.forEach(function(inp) {
      if (inp.name) data.append(inp.name, inp.value);
    });

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: data.toString()
    }).then(function() {
      form.reset();
      b2bCloseQuoteModal();
      b2bShowToast(sm24t('✓ Quote request sent! We respond within 1 business hour.', '✓ Angebotsanfrage gesendet! Wir antworten innerhalb einer Geschäftsstunde.'), 6000);
    }).catch(function() {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = origHTML; }
      b2bShowToast(sm24t('Error sending request. Please try again.', 'Fehler beim Senden. Bitte versuchen Sie es erneut.'), 4000);
    });

    return false;
  };

  /* ================================================================
     RECENTLY VIEWED (localStorage)
     NOTE: The b2b-product-recently-viewed.liquid section handles
     its own rendering (with demo seed). This JS only handles:
     - rvTrack(): recording the current product on page load
     - b2bClearRecentlyViewed(): exposed globally so the Clear button works
  ================================================================ */
  var RV_KEY = 'shopmed24_recently_viewed';

  function rvGet() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function rvTrack() {
    var data = window.B2B_DATA || {};
    if (!data.productId) return;
    try {
      var list = rvGet().filter(function (p) { return String(p.id) !== String(data.productId); });
      list.unshift({
        id:     String(data.productId),
        handle: data.handle  || '',
        title:  data.title   || '',
        vendor: data.vendor  || '',
        price:  data.price   || 0,
        image:  data.image   || '',
        url:    '/products/' + (data.handle || '')
      });
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  window.b2bClearRecentlyViewed = function () {
    localStorage.removeItem(RV_KEY);
    var sec = document.getElementById('b2bRecentlyViewedSection');
    if (sec) sec.style.display = 'none';
  };

  /* rvRender is handled entirely by the b2b-product-recently-viewed.liquid section's
     own inline script — no duplicate rendering needed here. */
  function rvRender() { /* no-op: section handles its own rendering */ }

  /* ================================================================
     STICKY BARS
  ================================================================ */
  function b2bUpdateStickyBars() {
    var btn         = document.getElementById('b2bAddToCartBtn');
    var stickyCta   = document.getElementById('b2bStickyCta');
    var stickyDesk  = document.getElementById('b2bStickyDesktop');
    if (!btn) return;
    var past = btn.getBoundingClientRect().bottom < 0;
    if (stickyCta)  stickyCta.classList.toggle('visible', past);
    if (stickyDesk) stickyDesk.classList.toggle('visible', past);
  }

  /* ================================================================
     SCROLL ANIMATIONS
  ================================================================ */
  function b2bInitAnimations() {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.b2b-anim-up, .b2b-anim-scale').forEach(function (el) { obs.observe(el); });
  }

  /* ================================================================
     COPY LINK (share)
  ================================================================ */
  window.b2bCopyLink = function () {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href).then(function () {
        b2bShowToast(sm24t('Link copied!', 'Link kopiert!'));
      });
    }
  };

  /* ================================================================
     CLOSE MODALS ON BACKDROP CLICK
  ================================================================ */
  function b2bInitModalBackdrops() {
    ['b2bProcurementModal', 'b2bQuoteModal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('click', function (e) {
        if (e.target === el) {
          b2bCloseProcurementModal();
          b2bCloseQuoteModal();
          document.body.style.overflow = '';
        }
      });
    });
  }

  /* ================================================================
     RELATED PRODUCTS — Quick Add to Cart
  ================================================================ */
  window.b2bRelatedAddToCart = function (variantId, btn) {
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="mat-icon material-symbols-outlined" style="font-size:20px;animation:b2b-pulse 1s infinite">hourglass_top</span>'; }
    fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      b2bRefreshCart();
      b2bShowToast(sm24t('Added to cart!', 'In den Warenkorb gelegt!'));
    })
    .catch(function () { b2bShowToast(sm24t('Error adding to cart.', 'Fehler beim Hinzufügen zum Warenkorb.'), 4000); })
    .finally(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = '<span class="mat-icon material-symbols-outlined" style="font-size:20px">add_shopping_cart</span>'; }
    });
  };

  /* ================================================================
     STICKY BAR — Add to Cart (reuses main form data)
  ================================================================ */
  window.b2bStickyAddToCart = function (btn) {
    var form = document.getElementById('b2bProductForm');
    if (!form) return;
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="mat-icon material-symbols-outlined" style="font-size:18px;animation:b2b-pulse 1s infinite">hourglass_top</span>&nbsp;Adding...';
    }
    var formData = new FormData(form);
    fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          b2bShowToast(data.description || sm24t('Could not add to cart.', 'Konnte nicht in den Warenkorb gelegt werden.'), 4000);
        } else {
          b2bShowToast(sm24t('Added to cart!', 'In den Warenkorb gelegt!'));
          b2bRefreshCart();
        }
      })
      .catch(function () { b2bShowToast(sm24t('Error adding to cart.', 'Fehler beim Hinzufügen zum Warenkorb.'), 4000); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
      });
  };

  /* ================================================================
     ADD TO CART (Shopify Ajax)
  ================================================================ */
  window.b2bHandleAddToCart = function (e) {
    e.preventDefault();
    var form = document.getElementById('b2bProductForm');
    if (!form) return;
    var btn = document.getElementById('b2bAddToCartBtn');
    var originalText = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="mat-icon material-symbols-outlined" style="font-size:18px;animation:b2b-pulse 1s infinite">hourglass_top</span>&nbsp;Adding...';
    }
    var formData = new FormData(form);
    fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        // error
        b2bShowToast(data.description || sm24t('Could not add to cart.', 'Konnte nicht in den Warenkorb gelegt werden.'), 4000);
      } else {
        b2bShowToast(sm24t('Added to cart!', 'In den Warenkorb gelegt!'));
        // Update cart count bubble if theme has one
        b2bRefreshCart();
      }
    })
    .catch(function () { b2bShowToast(sm24t('Error adding to cart.', 'Fehler beim Hinzufügen zum Warenkorb.'), 4000); })
    .finally(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
    });
  };

  /* ================================================================
     EUR FORMATTER — global so b2bSelectTier / b2bSelectVariant can call it
     from inline onclick attributes before DOMContentLoaded fires
  ================================================================ */
  window.b2bFormatEUR = function (cents) {
    /* SM24_DYNAMIC_MONEY_v1: delegate to the currency-aware formatter injected by theme.liquid
       (renders in the buyer's presentment currency - EUR, CHF, ...). Old EUR string as fallback. */
    if (window.SM24_fmtMoney) return window.SM24_fmtMoney(cents / 100);
    return '\u20AC' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  /* local alias for internal use */
  function b2bFormatEUR(cents) { return window.b2bFormatEUR(cents); }

  /* ================================================================
     INIT
  ================================================================ */
  ready(function () {
    var data     = window.B2B_DATA || {};
    var initQty  = data.minQty || 100;
    var initPrice = data.price || 0;

    // Force EUR symbol in all price displays (overrides store currency £/$ on dev stores)
    var euroStr = b2bFormatEUR(initPrice);
    var stickyPrice       = document.getElementById('b2bStickyPrice');
    var mobileStickyPrice = document.getElementById('b2bMobileStickyPrice');
    var displayPrice      = document.getElementById('b2bDisplayPrice');
    var cartTotal         = document.getElementById('b2bCartTotal');
    if (stickyPrice)       stickyPrice.textContent = euroStr;
    if (mobileStickyPrice) mobileStickyPrice.textContent = euroStr;
    if (displayPrice)      displayPrice.textContent = euroStr;

    // initial cart total + shipping bar
    b2bUpdateCart(initQty);

    // recently viewed
    rvTrack();
    rvRender();

    // procurement icon state
    b2bRenderProcurementIcon();

    // sticky bars
    window.addEventListener('scroll', b2bUpdateStickyBars, { passive: true });
    window.addEventListener('resize', b2bUpdateStickyBars);
    b2bUpdateStickyBars();

    // scroll animations
    b2bInitAnimations();

    // modal backdrops
    b2bInitModalBackdrops();

    // Add to cart form — use Ajax instead of page reload
    var form = document.getElementById('b2bProductForm');
    if (form) form.addEventListener('submit', window.b2bHandleAddToCart);
  });

  /* ================================================================
     DATASHEET PDF
     - If product has a metafield PDF URL → open it directly in new tab
     - Otherwise → auto-generate a professional B2B product datasheet
       as a printable HTML page (user can Print → Save as PDF)
  ================================================================ */
  window.b2bOpenDatasheet = function () {
    var data = window.B2B_DATA || {};

    // 1. If a real PDF URL is attached → just open it
    if (data.datasheetUrl && data.datasheetUrl !== 'null' && data.datasheetUrl !== '') {
      window.open(data.datasheetUrl, '_blank', 'noopener');
      return;
    }

    // 2. Build a professional auto-generated datasheet
    var price = data.price ? b2bFormatEUR(data.price) : '–';
    var comparePrice = data.comparePrice && data.comparePrice > 0
      ? b2bFormatEUR(data.comparePrice) : null;
    var minQty = data.minQty || 100;
    var productUrl = window.location.href;
    var today = new Date();
    var dateStr = today.toLocaleDateString(SM24_DE ? 'de-DE' : 'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    var docNum = 'SM24-' + (data.productId || '000') + '-DS';

    var imageHtml = data.image
      ? '<img src="' + data.image + '" alt="' + (data.title || '') + '" style="max-width:200px;max-height:200px;object-fit:contain;border-radius:8px;border:1px solid #e5e7eb"/>'
      : '';

    var variantsHtml = '';
    if (data.variants && data.variants.length > 1) {
      variantsHtml = '<table style="width:100%;border-collapse:collapse;font-size:12px;margin-top:8px">';
      variantsHtml += '<tr style="background:#f1f5f9"><th style="padding:6px 10px;text-align:left;border:1px solid #e2e8f0">Variante</th><th style="padding:6px 10px;text-align:right;border:1px solid #e2e8f0">Preis/VE</th><th style="padding:6px 10px;text-align:right;border:1px solid #e2e8f0">SKU</th></tr>';
      data.variants.forEach(function (v) {
        variantsHtml += '<tr><td style="padding:6px 10px;border:1px solid #e2e8f0">' + v.title + '</td><td style="padding:6px 10px;text-align:right;border:1px solid #e2e8f0">' + b2bFormatEUR(v.price) + '</td><td style="padding:6px 10px;text-align:right;border:1px solid #e2e8f0;color:#6b7280">' + (v.sku || '–') + '</td></tr>';
      });
      variantsHtml += '</table>';
    }

    var html = '<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8"><title>Datenblatt – ' + (data.title || 'Produkt') + '</title>' +
      '<style>' +
      'body{margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;color:#1a1f2e;background:#fff;font-size:13px}' +
      '@page{size:A4;margin:15mm 15mm 20mm 15mm}' +
      '@media print{.no-print{display:none!important}.page-break{page-break-before:always}}' +
      '.page{width:794px;min-height:1123px;margin:0 auto;padding:32px 40px;box-sizing:border-box}' +
      'h1{font-size:20px;font-weight:800;color:#1f2e35;margin:0 0 4px}' +
      'h2{font-size:13px;font-weight:700;color:#6ba4b8;text-transform:uppercase;letter-spacing:.08em;margin:20px 0 8px;border-bottom:1.5px solid #e5e7eb;padding-bottom:4px}' +
      'table.spec{width:100%;border-collapse:collapse}' +
      'table.spec td{padding:7px 10px;border-bottom:1px solid #f1f5f9;vertical-align:top}' +
      'table.spec td:first-child{font-weight:600;color:#374151;width:38%;background:#fafbfc}' +
      'table.spec td:last-child{color:#1a1f2e}' +
      '.header{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #1f2e35;padding-bottom:16px;margin-bottom:24px}' +
      '.logo-block .logo-text{font-size:22px;font-weight:900;color:#1f2e35;letter-spacing:-.02em}' +
      '.logo-block .logo-text span{color:#8db9ca}' +
      '.logo-block .tagline{font-size:10px;color:#6b7280;margin-top:2px}' +
      '.doc-meta{text-align:right;font-size:10px;color:#6b7280;line-height:1.7}' +
      '.doc-meta strong{color:#1f2e35}' +
      '.product-header{display:flex;gap:28px;align-items:flex-start;margin-bottom:20px}' +
      '.product-img{flex-shrink:0}' +
      '.product-info{flex:1}' +
      '.vendor-badge{display:inline-block;background:#e0f2fe;color:#0369a1;font-size:10px;font-weight:700;padding:2px 8px;border-radius:4px;margin-bottom:6px;text-transform:uppercase;letter-spacing:.06em}' +
      '.price-box{background:linear-gradient(135deg,#1f2e35,#1f2e35);color:#fff;border-radius:10px;padding:14px 18px;margin-top:14px;display:inline-block}' +
      '.price-box .price-label{font-size:10px;opacity:.6;margin-bottom:2px}' +
      '.price-box .price-val{font-size:22px;font-weight:800}' +
      '.price-box .price-unit{font-size:11px;opacity:.7;margin-left:4px}' +
      '.cert-row{display:flex;gap:10px;flex-wrap:wrap;margin-top:12px}' +
      '.cert-badge{display:inline-flex;align-items:center;gap:5px;border:1.5px solid #059669;color:#059669;border-radius:6px;padding:3px 9px;font-size:10px;font-weight:700;text-transform:uppercase}' +
      '.cert-badge.dark{border-color:#1f2e35;color:#1f2e35}' +
      '.disclaimer{background:#fef9c3;border:1px solid #fcd34d;border-radius:6px;padding:10px 12px;font-size:10px;color:#854d0e;margin-top:16px;line-height:1.5}' +
      '.footer{margin-top:32px;border-top:1px solid #e5e7eb;padding-top:12px;display:flex;justify-content:space-between;align-items:center;font-size:10px;color:#9ca3af}' +
      '.print-btn{position:fixed;bottom:24px;right:24px;background:#6ba4b8;color:#fff;border:none;padding:12px 22px;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;display:flex;align-items:center;gap:8px;box-shadow:0 4px 16px rgba(0,0,0,.2);font-family:Arial,sans-serif}' +
      '.print-btn:hover{background:#5a93a8}' +
      '</style></head><body>' +
      '<div class="page">' +

      // ── Header ──
      '<div class="header">' +
        '<div class="logo-block">' +
          '<div class="logo-text">Shop<span>Med</span>24</div>' +
          '<div class="tagline">B2B Medical Supplies Marketplace · shopmed24.de</div>' +
        '</div>' +
        '<div class="doc-meta">' +
          '<div><strong>Produktdatenblatt</strong></div>' +
          '<div>Dok.-Nr.: ' + docNum + '</div>' +
          '<div>Datum: ' + dateStr + '</div>' +
          '<div>Erstellt für: B2B-Kunden</div>' +
        '</div>' +
      '</div>' +

      // ── Product header ──
      '<div class="product-header">' +
        (imageHtml ? '<div class="product-img">' + imageHtml + '</div>' : '') +
        '<div class="product-info">' +
          '<div class="vendor-badge">✓ Verified Supplier — ' + (data.vendor || 'Medicalis') + '</div>' +
          '<h1>' + (data.title || 'Produktname') + '</h1>' +
          '<div style="font-size:12px;color:#6b7280;margin-top:4px">Art.-Nr.: <strong>' + (data.sku || '–') + '</strong>' +
            (data.productId ? ' &nbsp;|&nbsp; ID: ' + data.productId : '') +
          '</div>' +
          '<div class="price-box">' +
            '<div class="price-label">Preis pro VE (inkl. MwSt.)</div>' +
            '<div><span class="price-val">' + price + '</span><span class="price-unit">/ VE</span></div>' +
            (comparePrice ? '<div style="font-size:10px;opacity:.6;margin-top:3px;text-decoration:line-through">UVP: ' + comparePrice + '</div>' : '') +
          '</div>' +
          /* SM24_DS_NO_CLAIMS_v1 2026-10-18: CE/MDR badges + "Zertifizierung" row and the
             Mindestbestellmenge lines removed (no certification claims, no platform MOQ). */
          '<div class="cert-row">' +
            '<span class="cert-badge dark">B2B Only</span>' +
          '</div>' +
        '</div>' +
      '</div>' +

      // ── Specifications ──
      '<h2>Produktspezifikationen</h2>' +
      '<table class="spec">' +
        '<tr><td>Artikelbezeichnung</td><td>' + (data.title || '–') + '</td></tr>' +
        '<tr><td>Artikelnummer (SKU)</td><td>' + (data.sku || '–') + '</td></tr>' +
        '<tr><td>Lieferant / Hersteller</td><td>' + (data.vendor || 'Medicalis GmbH') + '</td></tr>' +
        '<tr><td>Preis pro VE</td><td>' + price + '</td></tr>' +
        '<tr><td>Liefergebiet</td><td>Deutschland, Österreich, Schweiz (DACH)</td></tr>' +
        '<tr><td>Produktseite</td><td style="word-break:break-all;font-size:11px">' + productUrl + '</td></tr>' +
      '</table>' +
      (variantsHtml ? '<h2>Verfügbare Varianten</h2>' + variantsHtml : '') +

      // ── Description ──
      (data.description
        ? '<h2>Produktbeschreibung</h2><div style="line-height:1.7;font-size:12px;color:#374151">' + data.description + '</div>'
        : '') +

      // ── Disclaimer ──
      '<div class="disclaimer">⚠ <strong>Hinweis:</strong> Dieses Produkt ist ausschließlich für zugelassene B2B-Kunden (Krankenhäuser, Kliniken, Praxen) bestimmt. Alle Angaben ohne Gewähr. Technische Änderungen vorbehalten. Bei Fragen wenden Sie sich an <strong>info@shopmed24.de</strong>.</div>' +

      // ── Footer ──
      '<div class="footer">' +
        '<div>ShopMed24 · Med24 GmbH (HRB 228844) · shopmed24.de · info@shopmed24.de</div>' +
        '<div>Seite 1 / 1 · Dok. ' + docNum + '</div>' +
      '</div>' +
    '</div>' +

    // ── Print button ──
    '<button class="print-btn no-print" onclick="window.print()">🖨 Als PDF speichern</button>' +
    '<script>window.onload = function(){ setTimeout(function(){ document.querySelector(".print-btn") && document.querySelector(".print-btn").focus(); }, 200); };<\/script>' +
    '</body></html>';

    var w = window.open('', '_blank', 'width=900,height=1100,scrollbars=yes');
    if (w) {
      w.document.write(sm24LocalizeDatasheet(html));
      w.document.close();
    } else {
      alert('Bitte Pop-ups für diese Seite erlauben, um das Datenblatt zu öffnen.');
    }
  };

})();
